module.exports = __webpack_public_path__ + "static/media/printing-services-img4.b51aaf2f.jpg";